"use strict";

var $ = require('jquery');
require('additionalMethods');
require('date');
var futureRules = require('./futureRules');
var validation = require('./validation');
var dateUtils = require('../utils/dateUtils');
var getErrorMessage = require('./validation').getErrorMessage;


// Store the old validation methods for delegation purposes
var $oldRequired = $.validator.methods.required;
var $oldCreditCard = $.validator.methods.creditcard;
var $oldIban = $.validator.methods.iban;
var $oldRange = $.validator.methods.range;

/**
 * Initialises common jquery validation functions
 */
function initValidations() {
    console.log("Initialising validations");

    addRequiredValidator();
    addGenericStringValidator();
    addPpsnValidator();
    addMobileNumberValidator();
    addIntlMobileNumberValidator();
    addIEAndUKMobileNumberValidator();
    addContactNumberValidator();
    addEmailAddressValidator();
    addPolicyNumberValidator();
    addDateFormatValidator();
    addBicValidator();
    addIbanValidator();
    addCvvValidator();
    addCreditCardNumberValidator();
    addCardExpiryDateValidator();
    addZipCodeValidator();
    addLcrLoadingValidator();
    addMonetaryAmountValidator();
    addRangeValidator();
    addInsurancePeriodValidator();
    addBreakPeriodValidator();
    addDateGreaterThanValidator();
    addDateLessThanValidator();
    addChildAgeValidator();
    addDatePeriodGreaterThanZeroValidator();
    addDateAfter2008Validator();
    addPersonNamesValidator();
    addMax9AdultsLimitValidator();
    addMax9ChildLimitValidator();
    addGreaterThanStartValidator();
    addAdultAgeValidator();
    addFutureBirthDateValidator();

    console.log("Initialising validations done.");
}

function addInsurancePeriodValidator() {
    $.validator.addMethod('insurance_period_require_from_group',
        $.validator.methods.require_from_group,
        function () {
            return getErrorMessage("previous.insurance.period.invalid");
        });
}

function addBreakPeriodValidator() {
    $.validator.addMethod('break_period_require_from_group',
        $.validator.methods.require_from_group,
        function () {
            return getErrorMessage("break.period.invalid");
        });
}


function addLcrLoadingValidator() {
    $.validator.addMethod(
        "validLoading",
        function (value, element, options) {
            if ((value === null) || (value === undefined)) {
                return false;
            } else {
                if (value % 2 !== 0) {
                    return false;
                } else {
                    if ((value < 0) || (value > 70)) {
                        return false;
                    }
                }
            }
            return true;
        },
        function (options) {
            return getErrorMessage('lcr.loading.invalid', options.errorKey);
        });
}

function addDatePeriodGreaterThanZeroValidator() {
    $.validator.addMethod('datePeriodGreaterThanZero', function (value, element, options) {
        var compareValue = $(element).parents('.form-group').find(options.compareSelector).val();
        console.log("Add value %s to selector value %s ", Number(value), Number(compareValue));
        return (Number(compareValue) + Number(value)) > 0;

    },
        function (options) {
            return getErrorMessage(options.errorKey);
        });
}


function addDateGreaterThanValidator() {
    $.validator.addMethod(
        "dateGreaterThan",
        function (value, element, options) {
            if (shouldValidateField(element)) {
                return true;
            }

            var baseElemDate = Date.parseExact(value, 'dd/MM/yyyy');
            if (baseElemDate === null) {
                console.log("Invalid date format on base Eleemnt input");
                return false;
            }
            console.log("Using a specific selector passed ", baseElemDate);

            var comparisonDate = new Date();
            if (options && typeof options === 'string') {
                Date.parseExact(options, 'yyyy-MM-dd');
            }

            if (comparisonDate === null) {
                console.log("Invalid date format on base comparison date input");
                return false;
            }

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + baseElemDate.compareTo(comparisonDate));
            if (baseElemDate.compareTo(comparisonDate) < 0) {
                console.log("Greater than check result = false");
                return false;
            } else {
                console.log("Greater than check result = true");
                return true;
            }
        },
        function (options) {
            return getErrorMessage("The end date must be after the start date", options.errorKey);
        });
}


function addDateLessThanValidator() {
    $.validator.addMethod(
        "dateLessThan",
        function (value, element, options) {
            if (shouldValidateField(element)) {
                return true;
            }

            var baseElemDate = Date.parseExact(value, 'dd/MM/yyyy');
            if (baseElemDate === null) {
                console.log("Invalid date format on base Eleemnt input");
                return false;
            }

            var comparisonDate = new Date();
            if (options && typeof options === 'string') {
                Date.parseExact(options, 'yyyy-MM-dd');
            }

            if (comparisonDate === null) {
                console.log("Invalid date format on base comparison date input");
                return false;
            }

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + baseElemDate.compareTo(comparisonDate));
            if (baseElemDate.compareTo(comparisonDate) < 0) {
                console.log("Date less than validation result=true");
                return true;
            } else {
                console.log("Date less than validation result=false");
                return false;
            }
        },
        function (options) {
            return getErrorMessage("The end date must be after the start date", options.errorKey);
        });
}



function addDateAfter2008Validator() {
    $.validator.addMethod(
        "dateAfter2008",
        function (value, element, options) {
            if (this.optional(element)) {
                return true;
            }

            console.log("Verifying date %s is after 2008.", value);

            /**
             * This is added to to trigger validation of the fromDate on the toDate blur event.
             */

            if (options.hasOwnProperty('compareSelector')) {
                var comparisonElement = $(options.compareSelector);
                if (!($(comparisonElement).length && $(comparisonElement).val().length)) {
                    console.log("Comparison element doesn't exist comparison value %s ", $(comparisonElement).val());
                    // default to valid - rely on server side validation
                    return true;
                }

                // override the value parameter with obtained from the comparison elementL
                value = $(comparisonElement).val();

                console.log("Validating name using specify selector " + $(element).prop('name'));
                console.log("This value is" + value + " looking for previous class " + options.compareSelector);
            }


            var testDate = Date.parseExact(value, 'dd/MM/yyyy');

            if (testDate === null) {
                console.log("Invalid date format on base Eleemnt input");
                return false;
            }

            var comparisonDate = Date.parseExact('01/01/2009', 'dd/MM/yyyy');

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + testDate.compareTo(comparisonDate));
            if (testDate.compareTo(comparisonDate) < 0) {
                console.log("dateAfter2008 check result = false");
                return false;
            } else {
                console.log("dateAfter2008 check result = true");
                return true;
            }

        },

        function (options) {
            return getErrorMessage("Only periods of unemployment after 2008 can be counted for LCR credit", options.errorKey);
        });
}



function addChildAgeValidator() {
    $.validator.addMethod("isChildDateOfBirth", function (value, element, options) {
        console.log("Validating child date of birth , value = ", value);
        var ageToCompare = options.age;
        console.log("Age to check", ageToCompare);
        var startDate = Date.parseExact(options.startDate, 'dd/MM/yyyy');
        var dobAsDate = Date.parseExact(value, 'dd/MM/yyyy');
        var atAge = new Date(dobAsDate.add({ years: ageToCompare }));
        console.log("Start date " + startDate);
        console.log("At age " + atAge);

        if (atAge.compareTo(startDate) === -1) {
            console.log("DOB + age is greater than start date");
            return false;
        }
        console.log("Validation successful for DOB age");
        return true;

    }, function (options) {
        return getErrorMessage("dateOfBirth.Input.CHILD.Invalid.HEALTH", options.errorKey);
    });
}


function addFutureBirthDateValidator() {
    $.validator.addMethod("isFutureDateOfBirth", function (value, element, options) {
            var baseElemDate = Date.parseExact(value, 'dd/MM/yyyy');
            if (baseElemDate === null) {
                console.log("Invalid date format on base Element input");
                return false;
            }
            console.log("Using a specific selector passed ", baseElemDate);

            var comparisonDate = new Date();
            if (options && typeof options === 'string') {
                Date.parseExact(options, 'yyyy-MM-dd');
            }

            if (comparisonDate === null) {
                console.log("Invalid date format on base comparison date input");
                return false;
            }

            console.log("Compaing against date " + comparisonDate);
            console.log("Comparison check is " + baseElemDate.compareTo(comparisonDate));
            if (baseElemDate.compareTo(comparisonDate) > 0) {
                console.log("Future date check result = false");
                return false;
            } else {
                console.log("Future date check result = true");
                return true;
            }
        },
        function (options) {
            return getErrorMessage("Birth date can not be a future date.", options.errorKey);
        });
}

function addAdultAgeValidator() {
    $.validator.addMethod("isAdultDateOfBirth", function (value, element, options) {
        console.log("Validating adult date of birth , value = ", value);
        var ageToCompare = 18;
        console.log("Age over to check ", ageToCompare);
        var startDate = new Date();//default today
        if (options){
            if (options.age) {ageToCompare=options.age;}
            if (options.startDate) {startDate = Date.parseExact(options.startDate, 'dd/MM/yyyy');}
        }
        var dobAsDate = Date.parseExact(value, 'dd/MM/yyyy');

        if (dobAsDate) {
            var atAge = new Date(dobAsDate.add({years: ageToCompare}));
            //console.log("Start date " + startDate);
            //console.log("At age " + ageToCompare + " will be in " + atAge);

            if (atAge.compareTo(startDate) === 1) {
                console.log("FAIL! DOB +18 is beyond start date/today !");
                return false;
            }
            console.log("Adult validation successful for DOB age");
            return true;
        }else{//date not extracted (incompleted date?)
            return false;
        }
    }, function (options) {
        return getErrorMessage("dateOfBirth.Input.ADULT.Invalid.HEALTH", options.errorKey);
    });
}




function addMax9AdultsLimitValidator() {
    $.validator.addMethod("max9adults", dobCounter(true), function (options) {
        return getErrorMessage("dateOfBirth.Input.ADULT.Invalid.HEALTH", options.errorKey);
    });
}


function addMax9ChildLimitValidator() {
    $.validator.addMethod("max9childs", dobCounter(false), function (options) {
        return getErrorMessage("dateOfBirth.Input.CHILD.Invalid.HEALTH", options.errorKey);
    });
}

/**
 *
 * @param countAdults true - if you want to count adults, false if you want to count children
 * @returns {adultCounter}
 */
function dobCounter(countAdults) {
    return function adultCounter(value, element, options) {
        var $element = $(element);
        var elId = $element.attr('id');
        var elName = $element.attr('name');
        var $form = $element.closest('form');

        var targetGroupCounter = 0;
        var dependantByAgeLimit = 9;//9 for each by default

        console.log("Validating max " + dependantByAgeLimit + " " + (countAdults ? "adults" : "children") + " for " + elId + ' name= ' + elName);

        var nameArray = elName.split('.');
        var nameToSearch = nameArray[nameArray.length-1];

        if (!nameToSearch) {
            console.error('Max insured count can\'t be calculated for input with name: '+ elName);
            return false;
        }

        $("input[name$=']." + nameToSearch + "']", $form).each(function (i, dateField) {
            var dateValue = $(dateField).val();
            if (dateValue) {
                var parsedDate = dateUtils.getDate(dateValue);
                if (parsedDate) {//invalid date
                    var isAdult = dateUtils.isAdult(parsedDate);
                    if (countAdults && isAdult || !countAdults && !isAdult) {
                        targetGroupCounter++;
                    }
                }
            }
        });//for each found DOB
        return targetGroupCounter <= dependantByAgeLimit;
    };
}


/* relies that two input relies on logic
 FROM date field name contains "start"  and TO datefield contains "end"
 in addition both fields has same "ref" number
 */
function addGreaterThanStartValidator() {
    $.validator.addMethod("greaterThanStart", function (value, element, options) {
        console.log("greaterThanStart validator called from " + $(element).attr('id') + ' name= ' + $(element).attr('name')+" ref="+$(element).attr('ref')+" npk="+$(element).attr('npk'));
        var startName= $(element).attr('name');
        startName = startName.replace("end","start");
        var result = true;

        $("input[name='" + startName + "'][npk="+$(element).attr('npk')+"][ref="+$(element).attr('ref')+"]").each(function (i, requiredField) {

            console.log("--CHECK GREATER THAN Start date :" +startName+" ref ="+$(element).attr('ref')+" npk="+$(element).attr('npk')+" for field:"+  $(requiredField).attr('id'));
            if ($(requiredField).val()) {
                var startDate = Date.parseExact($(requiredField).val(), 'dd/MM/yyyy');
                if (startDate === null) {//invalid date
                    console.log('----- STARTDATE check:' + $(requiredField).attr('id') + ' contains ' + $(requiredField).val() + ' - a invalid date!');
                    result = false;
                }
                else {
                    var endDate = Date.parseExact(value, 'dd/MM/yyyy');
                    var cmp = (endDate.compareTo(startDate));
                    console.log("check if startDate " + startDate + " in compare to endDate "+ endDate+ " ==" +cmp);
                    if (cmp === 1) {
                        console.log("OK>>> StartDate IS before EndDate!");
                        //result= true;//ok - default
                    }
                    else {
                        console.log("-- GREATER THAN Start date FAIL>>> StartDate IS BEHIND EndDate!");
                        result = false;
                    }
                }
            }
        });//for each found field

        return result;

    }, function (options) {
        return getErrorMessage("lcr.employment.dates.less.than", options.errorKey);
    });
}





function addGenericStringValidator() {
    $.validator.addMethod(
        /*
         * The name of the validation method.
         */
        "genericString",
        /*
         * Call to generate the required functions`	.
         */
        generateValidator(),
        /**
         * Function that generates the error message, based on the specific error
         * key. If no value is found for the specified key, the key itself is
         * returned, so that some error message is shown. 
         * 
         * @param options   Array of options consisting of options.errorKey - mandatory field. 
         * 					This is the key for the error message options.optional - optional field.
         * 					This indicates if the field is optional, defaults to true if not specified.
         */
        function (options) {
            return getErrorMessage("generic.string.Invalid", options.errorKey);
        });
}

/*
 * Prepares a validator for a PPSN
 */
function addPpsnValidator() {
    $.validator.addMethod(
        /*
         * The name of the validation method.
         */
        "ppsNumber",

        /*
         * Call to generate the required functions`	.
         */
        generateValidator("pps.number"),

        /**
         * Function that generates the error message, based on the specific error
         * key. If no value is found for the specified key, the key itself is
         * returned, so that some error message is shown. 
         * 
         * @param options   Array of options consisting of options.errorKey - mandatory field. 
         * 					This is the key for the error message options.optional - optional field.
         * 					This indicates if the field is optional, defaults to true if not specified.
         */
        function (options) {
            return getErrorMessage("PPSN.Input.Invalid", options.errorKey);
        });
}

/*
 * Prepares a validator for a mobile number
 */
function addMobileNumberValidator() {
    $.validator.addMethod("mobileNumber", function (value, element, options) {
        return validateField(value, "mobile.number", element);
    }, function (options) {
        return getErrorMessage("mobileNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for international mobile number for join-checkout-people page
 */
function addIntlMobileNumberValidator() {
    $.validator.addMethod("intlMobileNumber", function (value, element, options) {
        return validateField(value, "intl.mobile.number", element);
    }, function (options) {
        return getErrorMessage("mobileNumber.Input.Invalid", options.errorKey);
    });
}

function addIEAndUKMobileNumberValidator() {
    $.validator.addMethod("ieAndUkMobileNumber", function (value, element, options) {
        var mobileCode = $(element).parent().siblings().find("select").val();
        var mobileNumber = value;
        var fullNumber = combinePhoneCodeNumber(mobileCode, mobileNumber);
        return this.optional(element) || matchesIEAndUKFormat(fullNumber);
    }, function (options) {
        return getErrorMessage("mobileNumber.Input.Invalid", options.errorKey);
    });
}
/*
 * Prepares a validator for a contact number
 */
function addContactNumberValidator() {
    $.validator.addMethod("contactNumber", function (value, element, options) {
        return validateField(value, "contact.number", element);
    }, function (options) {
        return getErrorMessage("contactNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for an IBAN. This can validate general IBANs (Irish and foreign) or just Irish, by specifying
 * true for the irelandOnly switch in the options. This first validates the value using the inbuilt IBAN validator (which
 * does a "check digit" validation), and then against the custom VHI regex. Both must return true for the validation to pass.  
   */
function addIbanValidator() {
    $.validator.addMethod("iban", function (value, element, options) {
        if (shouldValidateField(element)) {
            var ibanCheckDigitResult = $oldIban.call(this, value, element, options);
            var customRegexValid = options.irelandOnly ? validateField(value, "iban.ireland.only", element) : validateField(value, "iban.general", element);
            var overallResult = ibanCheckDigitResult && customRegexValid;
            return overallResult;
        }

        // No error
        return true;
    }, function (options) {
        if (options.irelandOnly) {
            return getErrorMessage("IBAN.Input.Invalid.Ireland.Only", options.errorKey);
        }

        return getErrorMessage("IBAN.Input.Invalid.General", options.errorKey);
    });
}

/*
 * Prepares a validator for a credit card expiry date, which is made up of
 * two fields, which need to be validated together
 */
function addCardExpiryDateValidator() {
    $.validator.addMethod("cardExpiryDate", function (value, element, options) {
        if (shouldValidateField(element)) {
            var expiryMonth = $('#' + options.monthId).val();
            var expiryYear = $('#' + options.yearId).val();
            var firstOfThisMonth = getFirstDayOfMonth();

            // Minus one as JS dates are zero-based, whereas the select is
            // 1-based
            var expiry = new Date(expiryYear, expiryMonth - 1, 1);
            var valid = expiry >= firstOfThisMonth;

            return valid;
        }

        // No error
        return true;
    }, function (options) {
        return getErrorMessage("expiry.Year.Past", options.errorKey);
    });

    function getFirstDayOfMonth() {
        var nowDate = new Date();
        var firstOfThisMonth = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
        return firstOfThisMonth;
    }
}

/*
 * Prepares a validator for a BIC
 */
function addBicValidator() {
    $.validator.addMethod("bic", function (value, element, options) {
        return validateField(value, "bic", element);
    }, function (options) {
        return getErrorMessage("BIC.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a CVV number on a credit card
 */
function addCvvValidator() {
    $.validator.addMethod("cvv", function (value, element, options) {
        return validateField(value, "cvv", element);
    }, function (options) {
        return getErrorMessage("cvvNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a credit card number.
 * 
 * Firstly checks if it is a valid CC number, using in-built Luhn check. It also applies our own custom credit card 
 * regex (which further limits it to Visa and Mastercard). Only if both of these checks pass do we allow the value.
 */
function addCreditCardNumberValidator() {
    $.validator.addMethod("creditCardNumber", function (value, element, options) {
        if (shouldValidateField(element)) {
            var luhnResult = $oldCreditCard.call(this, value, element, options);
            var customValidateResult = validateField(value, "card.number", element);
            var overallResult = luhnResult && customValidateResult;

            return overallResult;
        }

        // No error
        return true;
    }, function (options) {
        return getErrorMessage("cardNumber.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for an email address
 */
function addEmailAddressValidator() {
    $.validator.addMethod("emailAddress", function (value, element, options) {
        return validateField(value, "email.address", element);
    }, function (options) {
        return getErrorMessage("emailAddress.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a VHI policy number
 */
function addPolicyNumberValidator() {
    $.validator.addMethod("policyNumber", function (value, element, options) {
        var optional = options.optional;

        if (optional || this.optional(element)) {
            return true;
        }

        console.log("Validating mandatory policy number ", value);
        return validateField(value, "policy.number", element);
    }, function (options) {
        $("#" + this.currentElements.attr('id') + '-error').remove();
        return getErrorMessage("policyNumber.Input.Empty", options.errorKey);
    });
}

/*
 * Prepares a validator for a date in for the format dd/MM/yyyy
 */
function addDateFormatValidator() {
    $.validator.addMethod("dateFormat", function (value, element, options) {
        console.log("dateFormat testing %s", value);

        var optional = options.optional;

        if (optional) {
            console.log("Validating optional date field ", value);
            return this.optional(element) || validateDateField(value, "date.format", element);
        }

        console.log("Validating mandatory date field ", value);

        var result = validateDateField(value, "date.format", element);

        console.log("date format valid = %s", result);

        return result;
    }, function (options) {
        return getErrorMessage("dateOfBirth.Input.Missing", options.errorKey);
    });
}

/*
 * Validates that a date is in the valid dd/MM/yyyy format. Usually this is for date of birth, but could be used 
 * for any manually inputted field that is a date.
 */
function validateDateField(value, regexKey, element) {
    var isValid = false;

    //do validation only if minlength is set
    if (shouldValidateField(element) && futureRules.elemHasNoFutureRule(element)) {

        // The field is visible so we should validate it, now do so.
        if (validateField(value, regexKey, element)) {
            var dateParts = value.split("/");
            var day = parseInt(dateParts[0], 10);
            var month = parseInt(dateParts[1], 10);
            var year = parseInt(dateParts[2], 10);
            var xdata = new Date(year, month - 1, day, 12, 0, 0, 0);

            if ((xdata.getUTCFullYear() === year) && (xdata.getUTCMonth() === month - 1) && (xdata.getUTCDate() === day)) {
                isValid = true;
            }
        }
    } else {
        // The field is not visible so its always valid
        isValid = true;
    }
    return isValid;
}

/*
 * Replaces the in-built JQuery "required" validator to allow specification
 * of an error message key as part of the rule, which removes the need for a
 * separate "messages" section. It simply delegates onto the underlying
 * JQuery "required" function to do the actual validation work.
 */
function addRequiredValidator() {
    $.validator.addMethod("required", function (value, element, options) {
        if (shouldValidateField(element)) {
            var result = $oldRequired.call(this, value, element, options);
            return result;
        }

        // No error
        return true;
    }, function (options) {
        return getErrorMessage("required.field", options.errorKey);
    });
}

/*
 * Prepares a validator for a ZIP code
 */
function addZipCodeValidator() {
    $.validator.addMethod("zipCode", function (value, element, options) {
        // Remove spaces dashes before validation, as per server side. 
        var strippedZipCode = value.replace(/[\s-]/g, '');
        console.log('Testing zip code: ', strippedZipCode);

        return validateField(strippedZipCode, "zip.code", element);
    }, function (options) {
        return getErrorMessage("zipCode.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a validator for a monetary field
 */
function addMonetaryAmountValidator() {
    $.validator.addMethod("moneyAmount", function (value, element, options) {
        var optional = options.optional;

        if (optional) {
            console.log("Validating optional money amount, value = ", value);
            return this.optional(element) || validateField(value, "money.amount", element);
        }

        console.log("Validating mandatory money amount, value = ", value);
        return validateField(value, "money.amount", element);
    }, function (options) {
        return getErrorMessage("monetary.Input.Invalid", options.errorKey);
    });
}

/*
 * Prepares a range validator for a field
 */
function addRangeValidator() {
    $.validator.addMethod("range", function (value, element, options) {
        if (shouldValidateField(element)) {
            return $oldRange.call(this, value, element, options.theRange);
        }
        // No error
        return true;
    }, function (options) {
        return getErrorMessage("range.Input.Invalid", options.errorKey);
    });
}




/*
 * Prepares a FirstName and LastName validator for a field
 * (extracted from WAM services signup) https://web-wam-05.vhihealthcare.net/access/js/common/customValidationRules.js [isName]
 *
 *
 * Validate name: has only letters and spaces
 * usage - isName: true
 * changes defect #33072 - need to support CASE INSENSIVE character names with spaces, dashes and apostrophes
 * changes defect #33779 - need support accent characters: fadas and umlauts    ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÑÒÓÔÕÖØÙÚÛÜßàáâãäåæçèéêëìíîïñòóôõöøùúûüÿµ
 * roolback WAM PHASE2 - remove accent character support (18.10.2016)
 *
 * Requirement Change 2017-12-06 by David Conway , two spaces in a row is acceptable, "O'Conor" variant "O'  Conor" is accepted now too.
 * O’  Mahony
 * Mc  Dermott

 * no digits or other characters allowed
 * NOT WORKING with UNICODE OTHER symbols except fadas and umlauts above ( U+0080–U+00FF ,  U+0100–U+017F ,  U+0180–U+024F , U+0400–U+04FF )
 * ! Beware ! - passed names must be compatible with ActiveDirectory LDAP, GIOS and KANA
 *
 * tested patterns:
 *   STEVE SMITH (pass)
 *   Stev3 Smith (fail - numbers)
 *   STeve Smith (pass)
 *   Steve+SMith (fail - other spec-char than space/'/- )
 *   d'Are to Beaware (pass)
 *   Jo Blow (passed)
 *   D C
 *   Hyoung Kyoung Wu (passed)
 *   Mike O'Neal (passed)
 *   Steve Johnson-Smith (passed)
 *   Jozef-Schmozev Hiemdel (passed)
 *   O Henry Smith (passed)
 *   Mathais d'Arras (passed)
 *   Martin Luther King Jr (passed)
 *   Downtown-James Brown (passed)
 *   Darren McCarty (passed)
 *   George De FunkMaster (passed)
 *   Kurtis B-Ball Basketball (passed)
 *   Ahmad el Jeffe (passed)
 *   Jamal-  (fail)
 *   Difu--Hund (fail)
 *   Ärnstain Höffer (PASS NOW - extended ASCII chars), NOT PASS- removed
 */
function addPersonNamesValidator() {
    $.validator.addMethod("personNames", function (value, element, options) {
        var regex = new RegExp('^([A-Za-z]{1,30}[ ]{0,2}|[A-Za-z]{1,30}[- \']{1}[ ]{0,2}[A-Za-z]{1,30}){1,5}$');
        var result = regex.test(value);
        return result;
    },
        function (options) {
            return "Incorrect characters used, please enter using A-Z or a-z only.";
        });
}

/*
 * Validates the specified value against the specified regular expression
 * @param value The value to test 
 * @param regex The regexKey to validate against
 * @param element The element containing the value
 */
function validateField(value, regexKey, element) {
    var validationRegexes = validation.validationRegexes;
    var regex = new RegExp(validationRegexes[regexKey]);
    console.log("Validating against %s on element '%s'", regex, element.id);

    if (shouldValidateField(element)) {
        console.log("Validating against %s", regex);
        return regex.test(value);
    }

    return true;
}

/*
 * Check if the specified field should be validated.
 * 
 * @return true if the field is visible, false otherwise. If the type is "hidden", we check the parent node (as a
 * hidden field will never be visible). An example of this is the "type-ahead county" field, where the validated 
 * field is actually a hidden field. 
 */
function shouldValidateField(element) {
    var result = false;
    if (element.type === "hidden") {
        result = isVisible(element.parentNode);
    } else {
        result = isVisible(element) && futureRules.elemHasNoFutureRule(element);
    }

    return result;

}

/*
 * Function to test if the specified element is visible
 * 
 * @param The element to test ("regular" JS object, not JQuery) 
 */
function isVisible(element) {
    return $(element).is(':visible');
}


/**
 * Generate validation function.
 * <p>
 * This a builder for the function that performs the actual validation.
 * </p> 
 * 
 * @param regexKeyOverride provides the ability to override the regex key defined in options.
 * 
 */
function generateValidator(regexKeyOverride) {

    /**
     * The validation function implementation.
     * 
     * @param value The value of the element 
     * @param element The element being validated 
     * @param options Array of options consisting of:
     * <ul>	  
     * <li>options.errorKey - mandatory field. This is the key for the error message.</li>
     * <li>options.regexKey - optional field. This indicates the validation should use a custom regex key, falling back to "generic.string" as the key if this is omitted.</li>
     * </ul>
     */
    return function (value, element, options) {
        // Trim any spaces from the end of the string.
        value = value.trim();
        var regexKey = (options.regexKey) ? options.regexKey : "generic.string";
        if (regexKeyOverride) {
            regexKey = regexKeyOverride;
        }
        var result = null;

        result = this.optional(element) || validateField(value, regexKey, element);

        return result;
    };
}

function combinePhoneCodeNumber(phoneCode, phoneNumber) {
    var mobileNumberWithCountryCode = null;
    if ((phoneCode !== null && phoneNumber !== null) && (!isNaN(phoneNumber))) {
        mobileNumberWithCountryCode = phoneCode.concat("-").concat(phoneNumber);
    }
    return mobileNumberWithCountryCode;
}

function matchesIEAndUKFormat(mobileNumber) {
    var splittedNumber = mobileNumber.split("-", 2);
    var countryCode = splittedNumber[0];
    var strippedMobileNumber = splittedNumber[1];
    var isValid = true;
    if (countryCode === "+353") {
        var ieRegex = new RegExp(/^(08|8)[0-9]{8}$/);
        isValid = ieRegex.test(strippedMobileNumber);
    }
    if (countryCode === "+44") {
        var ukRegex = new RegExp(/^(07|7)[0-9]{9}$/);
        isValid = ukRegex.test(strippedMobileNumber);
    }
    return isValid;
}

/**
 * Page init function that is called when the module is loaded
 */
function pageInitialisation() {
    initValidations();
}

pageInitialisation();

module.exports.getErrorMessage = getErrorMessage;
module.exports.shouldValidateField = function (element) {
    return shouldValidateField(element);
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/forms/commonValidations.js
// module id = r1X9
// module chunks = 1 2